// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2hdtr","dragIcon":"SortableItem_dragIcon__pFh1k","disabled":"SortableItem_disabled__3SmDV"};